__turbopack_context__.v({
  "backgroundColor": "X-lMgW_backgroundColor",
  "cellBottomDividerColor": "X-lMgW_cellBottomDividerColor",
  "cellBottomDividerColorMobile": "X-lMgW_cellBottomDividerColorMobile",
  "closeBtn": "X-lMgW_closeBtn",
  "xCircleSvg": "X-lMgW_xCircleSvg",
});
